export default __webpack_public_path__ + "static/media/mpinJC.c4e55331.png";